/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, warp-drive/no-legacy-request-patterns */
// Extends From
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
// Ember Imports
import { action } from '@ember/object';
import { service } from '@ember/service';
// Internal Imports
import MediaType from '@linc-technologies/linced-common/enums/media-type';
import SharingLevel from '@linc-technologies/linced-common/enums/media-sharing-level';
import { getKeyAndSourceFromUpload } from '@linc-technologies/linced-common/utils/uppy';
import { tagName } from '@ember-decorators/component';

/**
 * change-profile-image provides a component to enable a user to change their
 * password.
 */
@tagName('')
export default class ChangeProfileImage extends Component {
  // Component versioning
  @tracked visualStyle = 'v1';

  // Services
  @service
  session;

  @service
  store;

  @service
  toaster;

  // State
  @tracked
  uppyDashboardOpen = false;

  @tracked
  uploading = false;

  @action
  openUppyDashboard() {
    this.uppyDashboardOpen = true;
  }

  @action
  closeUppyDashboard() {
    this.uppyDashboardOpen = false;
  }

  @action
  startUpload() {
    this.uploading = true;
  }

  @action
  handleUpload(file, upload) {
    let { key, mediaSource } = getKeyAndSourceFromUpload(upload);

    let person = this.get('session.person');

    const record = {
      schoolId: this.get('session.school'),
      personId: person,
      sharedWith: SharingLevel.PUBLIC,
      mediaType: MediaType.IMAGE,
      mediaSource: mediaSource,
      mimeType: file.type,
      fileName: file.name,
      storageKey: key,
      fileSize: file.size,
    };
    this.store
      .createRecord('media', record)
      .save()
      .then((media) => {
        person.set('profileMedia', media.id);
        return person.save();
      })
      .then(() => {
        this.toaster.success(`Profile image saved!`);
      })
      .catch(() => {
        // Revert unsaved changes, i.e. the profileMedia
        person.rollbackAttributes();
        this.toaster.error(`Error saving profile image!`);
      })
      .then(() => {
        this.uploading = false;
      });
  }

  @action
  handleUploadError() {
    this.toaster.error(`Error saving profile image!`);
    this.uploading = false;
  }
}
